import styled, {css} from 'styled-components'
import {Button} from '@components/ui/button/Button.tsx'

export const StyledFilterDatePickerGrid = styled.div(
    () => css`
        display: grid;
        grid-template-columns: auto minmax(0, 1fr);
    `
)

export const StyledOptionsWrapper = styled.div(
    ({theme: {spacing, palette}}) => css`
        padding: ${spacing * 3}px ${spacing * 4}px;
        display: flex;
        flex-direction: column;
        gap: ${spacing}px;
        border-right: 1px solid ${palette.neutral[200]};
    `
)

export const StyledFilterDatePickerFooter = styled.div(
    ({theme: {spacing, palette}}) => css`
        display: flex;
        width: 100%;
        justify-content: end;
        padding: ${spacing * 4}px;
        border-top: 1px solid ${palette.neutral[200]};
    `
)

export const StyledCalendarTriggerButton = styled(Button)`
    flex-shrink: 0;
`

export const StyledSelectRangeButton = styled(Button)<{isSelected?: boolean}>(
    ({theme: {palette}, isSelected}) => css`
        justify-content: space-between;
        ${isSelected &&
        css`
            background-color: ${palette.neutral[100]};
        `}
    `
)
